import clsx from "clsx";
import { compareDesc, format, isSameDay, isValid } from "date-fns";
import { it } from "date-fns/locale/it";
import React, { ReactNode, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { keycloak } from "../../../lib/keycloak/index.ts";
import { NewObjectService } from "../../../lib/object/service.ts";
import { findFileById, setFindDocumentStatus } from "../../../lib/object/slice.ts";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts";
import { capitalize, groupBy } from "../../../lib/utilis/index.ts";
import { colors } from "../../../ui/colors.ts";
import { CalendarIcon } from "../../../ui/icons/calendarIcon.tsx";
import { CheckIcon } from "../../../ui/icons/checkIcon.tsx";
import { ClockIcon } from "../../../ui/icons/clockIcon.tsx";
import { DownloadIcon } from "../../../ui/icons/downloadIcon.tsx";
import { EditIcon } from "../../../ui/icons/editIcon.tsx";
import { TrashIcon } from "../../../ui/icons/trashIcon.tsx";
import { LayoutComponent } from "../../../ui/layout/index.tsx";
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx";
import { Pills } from "../../../ui/molecules/pills/index.tsx";
import { SpinnerComponent } from "../../../ui/molecules/spinner/index.tsx";
import { ConfirmModal } from "../../../ui/organisms/confirmModal/index.tsx";
import Datepicker from "../../../ui/organisms/datepicker/Datepicker.tsx";
import { Dropdown } from "../../../ui/organisms/dropDown/index.tsx";
import { EmptyList } from "../../../ui/organisms/emptyList/index.tsx";
import { ErrorPopup } from "../../../ui/organisms/errorPopup/index.tsx";
import { HeadingSize } from "../../../ui/organisms/heading/dto.ts";
import { HeadingComponent } from "../../../ui/organisms/heading/index.tsx";
import { MenuItems } from "../../../ui/organisms/sidebar/dto.ts";
import { SuccessPopup } from "../../../ui/organisms/successPopup/index.tsx";
import { AppointmentsStatus, AppointmentsType, AppointmentsTypology, statusAppointmentMap } from "../../financialAdvisor/appointments/dto.ts";
import { NewAppointmentModal } from "../../financialAdvisor/appointments/newAppointmentModal.tsx";
import { appointmentsDelete, findAllAppointments, findByIdAppointment, setAppointmentCreareStatus, setAppointmentDeleteStatus, setModalAppointmentType, setNewAppointmentModal, setOpenAppointmentConfirmOrDenyModal, setRescheduleAppointmentStatus } from "../../financialAdvisor/appointments/slice.ts";
import { DocumentF24Status, statusF24Map } from "../documents/dto.ts";
import { UpdateStatusF24Modal } from "../documents/f24/updateStatusF24Modal.tsx";
import { findByIdDocument, setDocumentId, setFindByIdDocumentStatus, setUpdateStatusF24Modal, updateStatusF24 } from "../documents/slice.ts";
import { CompanyStatus } from "../dto.ts";
import { EventStatus, EventType } from "./dto.ts";
import { NewEventModal } from "./newEventModal.tsx";
import { deleteEvent, findAllEvents, setCreateEventStatus, setDeleteEventStatus, setEditEventDate, setEditEventId, setEditEventName, setEditEventNote, setEditEventStatus, setFindAllEventsStatus, setModalEventType, setNewEventDate, setOpenConfirmOrDenyModal, setOpenNewEventsModal } from "./slice.ts";

export function Events() {
    const eventsState = useAppSelector(state => state.events)
    const companyState = useAppSelector(state => state.company)
    const layoutState = useAppSelector(state => state.layout)
    const documentState = useAppSelector(state => state.document)
    const authState = useAppSelector(state => state.auth)
    const appointmentsState = useAppSelector(state => state.appointments)

    const dispatch = useAppDispatch()

    const objectService = NewObjectService()

    const navigate = useNavigate()

    enum Type {
        event = "event",
        appointment = "appointment"
    }

    interface MergedList {
        id: string
        type: EventType | AppointmentsType
        date: string
        endDate: string
        title: string
        note: string
        status: EventStatus | AppointmentsStatus
        f24Status?: DocumentF24Status
        documentId?: string
        typology?: AppointmentsTypology
        eventType: Type
    }


    const [isDelete, setIsDelete] = useState<string | undefined>()
    const [isDeleteAppointment, setIsDeleteAppointment] = useState<string | undefined>()
    const [listedEvents, setListedEvents] = useState<ReactNode[]>([])
    const isUnder1000 = useMediaQuery({ query: '(max-width: 1000px)' })

    let _list: MergedList[] = []

    useEffect(() => {
        if ((authState.findMeCompanyResponse !== undefined || companyState.findByIdCompanyResponse) && eventsState.eventsFilters.companyId !== 0) {
            dispatch(findAllEvents(eventsState.eventsFilters))
            dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.company, fromDate: eventsState.eventsFilters.fromDate, toDate: eventsState.eventsFilters.toDate }, period: "company", }));
        }
    }, [authState.findMeCompanyResponse, companyState.findByIdCompanyResponse])

    useEffect(() => {
        if (eventsState.eventsFilters.companyId !== 0) {
            dispatch(findAllEvents(eventsState.eventsFilters))
            dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.company, fromDate: eventsState.eventsFilters.fromDate, toDate: eventsState.eventsFilters.toDate }, period: "company" }));
        }
    }, [eventsState.eventsFilters.fromDate, appointmentsState.filters.company.fromDate])

    useEffect(() => {
        if (eventsState.editEventStatus === "successfully" || appointmentsState.appointmentsRescheduleStatus === "successfully") {
            dispatch(findAllEvents(eventsState.eventsFilters))
            dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.company, fromDate: eventsState.eventsFilters.fromDate, toDate: eventsState.eventsFilters.toDate }, period: "company" }));
        }
    }, [eventsState.editEventStatus, appointmentsState.appointmentsRescheduleStatus])

    useEffect(() => {
        if (eventsState.deleteEventStatus === "successfully" || appointmentsState.appointmentsDeleteStatus === "successfully") {
            dispatch(findAllEvents(eventsState.eventsFilters))
            dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.company, fromDate: eventsState.eventsFilters.fromDate, toDate: eventsState.eventsFilters.toDate }, period: "company" }));
        }
    }, [eventsState.deleteEventStatus, appointmentsState.appointmentsDeleteStatus])

    useEffect(() => {
        if (eventsState.updateEventStatusStatus === "successfully") {
            dispatch(findAllEvents(eventsState.eventsFilters))
        }
    }, [eventsState.updateEventStatusStatus])

    useEffect(() => {
        if (documentState.updateStatusF24Status === "successfully") {
            dispatch(findAllEvents(eventsState.eventsFilters))
        }
    }, [documentState.updateStatusF24Status])

    useEffect(() => {
        if ((appointmentsState.appointmentsCreationStatus === "successfully" || eventsState.eventCreationStatus === "successfully")) {
            dispatch(findAllEvents(eventsState.eventsFilters))
            dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.company, fromDate: eventsState.eventsFilters.fromDate, toDate: eventsState.eventsFilters.toDate }, period: "company" }));
        }
    }, [appointmentsState.appointmentsCreationStatus, eventsState.eventCreationStatus])

    let body: ReactNode[] = []

    body.push(
        <>
            <SuccessPopup
                active={eventsState.eventCreationStatus === 'successfully'}
                close={() => dispatch(setCreateEventStatus('idle'))}
                message="Evento aggiunto"
            />
            <ErrorPopup
                active={eventsState.eventCreationStatus === 'failed'}
                close={() => dispatch(setCreateEventStatus('idle'))}
                message="Si è verificato un errore durante la creazione dell'evento"
            />
            <SuccessPopup
                active={eventsState.editEventStatus === 'successfully'}
                close={() => dispatch(setEditEventStatus('idle'))}
                message="Evento modificato"
            />
            <ErrorPopup
                active={eventsState.editEventStatus === 'failed'}
                close={() => dispatch(setEditEventStatus('idle'))}
                message="Si è verificato un errore durante la modifica dell'evento"
            />
            <SuccessPopup
                active={eventsState.deleteEventStatus === 'successfully'}
                close={() => dispatch(setDeleteEventStatus('idle'))}
                message="Evento eliminato"
            />
            <ErrorPopup
                active={eventsState.deleteEventStatus === 'failed'}
                close={() => dispatch(setDeleteEventStatus('idle'))}
                message="Si è verificato un errore durante l'eliminazione dell'evento"
            />
            <SuccessPopup
                active={appointmentsState.appointmentsCreationStatus === 'successfully'}
                close={() => dispatch(setAppointmentCreareStatus('idle'))}
                message="Appuntamento creato correttamente."
            />
            <ErrorPopup
                active={appointmentsState.appointmentsCreationStatus === 'failed'}
                close={() => dispatch(setAppointmentCreareStatus('idle'))}
                message="Si è verificato un errore durante la creazione dell'appuntamento"
            />
            <SuccessPopup
                active={appointmentsState.appointmentsRescheduleStatus === 'successfully'}
                close={() => dispatch(setRescheduleAppointmentStatus('idle'))}
                message="Data e orario dell'appuntamento modificati correttamente"
            />
            <ErrorPopup
                active={appointmentsState.appointmentsRescheduleStatus === 'failed'}
                close={() => dispatch(setRescheduleAppointmentStatus('idle'))}
                message="Si è verificato un errore durante la modifica dell'appuntamento."
            />
            <SuccessPopup
                active={appointmentsState.appointmentsDeleteStatus === 'successfully'}
                close={() => dispatch(setAppointmentDeleteStatus('idle'))}
                message="Appuntamento eliminato correttamente."
            />
            <ErrorPopup
                active={appointmentsState.appointmentsDeleteStatus === 'failed'}
                close={() => dispatch(setAppointmentDeleteStatus('idle'))}
                message="Si è verificato un errore durante l'eliminazione dell'appuntamento."
            />
            <div className={clsx("flex flex-row gap-6 flex-grow", {
                "flex-col-reverse": isUnder1000
            })}>
                <div className={"flex w-full flex-grow"}>
                    {
                        eventsState.findAllEventsStatus === 'loading' ||
                            eventsState.eventCreationStatus === 'loading' ||
                            eventsState.deleteEventStatus === 'loading' ||
                            eventsState.editEventStatus === 'loading' ||
                            appointmentsState.appointmentsDeleteStatus === "loading" ||
                            appointmentsState.appointments.company.status === "loading" ||
                            appointmentsState.appointmentsCreationStatus === "loading" ||
                            appointmentsState.appointmentsRescheduleStatus === "loading" ||
                            eventsState.updateEventStatusStatus === 'loading' ?
                            (
                                <div className={"flex justify-center items-center flex-grow"}>
                                    <SpinnerComponent />
                                </div>
                            ) : (
                                eventsState.findAllEventsResponse?.total === 0 && appointmentsState.appointments.company.data?.data.length === 0 ?
                                    (
                                        <div className={"flex justify-center items-center flex-grow"}>
                                            <EmptyList />
                                        </div>
                                    ) :
                                    (
                                        <div
                                            className={clsx("flex items-center justify-start flex-grow flex-col gap-2 overflow-auto p-r-[10px]", {
                                                "max-h-[65vh]": companyState.selectedOperationTab === 4,
                                                "max-h-[85vh]": companyState.selectedOperationTab === 0,
                                                "max-h-[55vh]": window.location.pathname === '/'
                                            })}
                                        >
                                            {listedEvents.length > 0 ? listedEvents : <EmptyList />}
                                        </div>
                                    )
                            )
                    }
                </div>
                {window.location.pathname !== '/' && <div className=" w-full">
                    <Datepicker
                        onClick={(date) => {
                            if (isValid(new Date(date)))
                                dispatch(setNewEventDate(format(new Date(date), 'yyyy-MM-dd')))
                            else {
                                dispatch(setNewEventDate(format(new Date(), 'yyyy-MM-dd')))
                            }
                            dispatch(setModalEventType('save'))
                            dispatch(setOpenNewEventsModal(true))
                        }}
                    />
                </div>}
            </div>
            <NewEventModal />
            <NewAppointmentModal />
            <UpdateStatusF24Modal />
            <ConfirmModal
                open={eventsState.openConfirmOrDenyModal}
                handleClose={() => dispatch(setOpenConfirmOrDenyModal(false))}
                title={"Elimina evento"}
                description={"Sei sicuro di voler eliminare questo evento?"}
                labelDeny={"Annulla"}
                labelConfirm={"Elimina"}
                actionConfirm={() => {
                    isDelete && dispatch(deleteEvent(isDelete))
                    dispatch(setOpenConfirmOrDenyModal(false))
                }}
            />
            <ConfirmModal
                open={appointmentsState.openAppointmentConfirmOrDenyModal}
                handleClose={() => dispatch(setOpenAppointmentConfirmOrDenyModal(false))}
                title={"Elimina appuntamento"}
                description={"Sei sicuro di voler eliminare questo appuntamento?"}
                labelDeny={"Annulla"}
                labelConfirm={"Elimina"}
                actionConfirm={() => {
                    isDeleteAppointment && dispatch(appointmentsDelete(isDeleteAppointment))
                    dispatch(setOpenAppointmentConfirmOrDenyModal(false))
                }}
            />
        </>
    )

    useEffect(() => {
        if (
            eventsState.findAllEventsStatus === 'successfully' &&
            eventsState.findAllEventsResponse &&
            eventsState.findAllEventsResponse.data &&
            appointmentsState.appointments.company.status === "successfully"
        ) {
            let temp: ReactNode[] = []
            _list = [
                ...eventsState.findAllEventsResponse?.data.filter(item => window.location.pathname !== '/' ? item : (new Date(item.date) > new Date() || isSameDay(new Date(item.date), new Date()))).map(event => ({ date: format(event.date, 'yyyy-MM-dd'), endDate: format(event.date, 'yyyy-MM-dd'), title: event.name, note: event.note, id: event.id, type: event.type, status: event.status, f24Status: event.f24Status, documentId: event.documentId, eventType: Type.event }))!,
                ...appointmentsState.appointments.company.data?.data.filter(item => window.location.pathname !== '/' ? item : (new Date(item.startDate) > new Date() || isSameDay(new Date(item.startDate), new Date()))).map(event => ({ date: format(event.startDate, 'yyyy-MM-dd HH:mm'), endDate: format(event.endDate, 'yyyy-MM-dd HH:mm'), title: event.title, note: event.notes, id: event.id, type: event.type, status: event.status, typology: event.typology, eventType: Type.appointment }))!,
            ]
            groupBy(_list, 'endDate').sort((a, b) => new Date(a.key as unknown as string).getTime() - new Date(b.key as unknown as string).getTime()).forEach(eventByDay => {
                temp.push(
                    <div
                        onClick={() => { if (window.location.pathname === '/') navigate('/calendar') }}
                        key={eventByDay.key.toString()}
                        className={"cursor-pointer flex flex-row items-start px-1 py-3 border-[0.5px] border-neutral-300 w-full rounded-xl relative"}
                    >
                        <div className={"w-[56px] px-0 py-1 flex flex-col gap-[2px]"}>
                            <span
                                style={{
                                    color: (format(new Date(eventByDay.key), 'EEEE') === 'Sunday' ? colors.red[500] : colors.neutral[500]),
                                }}
                                className={"text-label-xs font-medium text-center"}
                            >
                                {format(new Date(eventByDay.key), 'eee', { locale: it }).toUpperCase()}
                            </span>
                            <span
                                style={{
                                    color: (format(new Date(eventByDay.key), 'EEEE') === 'Sunday' ? colors.red[500] : layoutState.theme[500]),
                                }}
                                className={"text-label-lg font-bold text-center"}
                            >
                                {format(new Date(eventByDay.key), 'dd')}
                            </span>
                        </div>
                        <div
                            className={"h-full w-[1px] bg-neutral-200"}
                        />
                        <div className={"flex flex-col items-start gap-2 w-full"}>
                            {
                                eventByDay.values.map((event, index) =>
                                    <>
                                        <div
                                            key={event.id}
                                            className={"flex px-4 py-1 flex-col items-start flex-grow w-full relative"}
                                        >
                                            <div className={"flex flex-col items-start justify-start gap-1"}>
                                                <div className="flex gap-4">
                                                    {
                                                        event.type === EventType.F24 &&
                                                        (
                                                            <>
                                                                {
                                                                    event.status === EventStatus.NotResolved &&
                                                                    (
                                                                        compareDesc(new Date(event.date), new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) !== -1 ?
                                                                            <Pills
                                                                                key={event.id}
                                                                                label={"Scaduto"}
                                                                                size={"xs"}
                                                                                color={"orange"}
                                                                                emphasis={false}
                                                                                outline={false}
                                                                            />
                                                                            :
                                                                            <Pills
                                                                                key={event.id}
                                                                                label={"In attesa"}
                                                                                size={"xs"}
                                                                                color={"blue"}
                                                                                emphasis={false}
                                                                                outline={false}
                                                                            />
                                                                    )
                                                                }
                                                                <Pills
                                                                    size={"xs"}
                                                                    label={statusF24Map.get(event.f24Status!)!}
                                                                    outline={false}
                                                                    emphasis={true}
                                                                    color={event.f24Status === DocumentF24Status.Idle ? "blue" : event.f24Status === DocumentF24Status.Delay ? 'red' : 'green'}
                                                                />
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        event.eventType === Type.appointment &&
                                                        <div className="flex gap-4">
                                                            <Pills
                                                                key={event.id}
                                                                label={"Appuntamento"}
                                                                size={"xs"}
                                                                color={"blue"}
                                                                emphasis={true}
                                                                outline={false}
                                                            />
                                                            <Pills
                                                                key={event.id}
                                                                label={statusAppointmentMap.get(event.status as AppointmentsStatus)!}
                                                                size={"xs"}
                                                                color={event.status === AppointmentsStatus.pending ? "orange" : "green"}
                                                                emphasis={event.status === AppointmentsStatus.pending ? false : true}
                                                                outline={false}
                                                            />
                                                            <Pills
                                                                size={"xs"}
                                                                label={format(event.date, "HH:mm") + "-" + format(event.endDate, "HH:mm")}
                                                                outline={false}
                                                                emphasis={false}
                                                                color={"blue"}
                                                            />
                                                        </div>
                                                    }
                                                    {
                                                        (companyState.selectedOperationTab !== 0 || window.location.pathname === "/calendar") &&
                                                        <div className=" absolute top-[10%] right-[1%]">
                                                            <Dropdown
                                                                items={[
                                                                    {
                                                                        visible: event.type === EventType.F24,
                                                                        label: event.eventType === Type.event ? 'Modifica' : (keycloak.hasRealmRole('company') || keycloak.hasRealmRole('administrative_company')) ? 'Visualizza' : 'Modifica',
                                                                        icon: <EditIcon color="" size={""} />,
                                                                        onClick: () => {
                                                                            if (event.eventType === Type.event) {
                                                                                dispatch(setModalEventType('edit'))
                                                                                dispatch(setEditEventName(event.title))
                                                                                dispatch(setEditEventDate(format(new Date(event.date), 'yyyy-MM-dd')))
                                                                                dispatch(setEditEventNote(event.note))
                                                                                dispatch(setEditEventId(event.id))
                                                                                dispatch(setOpenNewEventsModal(true))
                                                                            } else {
                                                                                dispatch(setModalAppointmentType("edit"))
                                                                                dispatch(findByIdAppointment(event.id))
                                                                                dispatch(setNewAppointmentModal(true))
                                                                            }

                                                                        }
                                                                    },
                                                                    {
                                                                        visible: event.type !== EventType.F24,
                                                                        label: 'Scarica',
                                                                        icon: <DownloadIcon size={"24"} color={""} />,
                                                                        onClick: () => {
                                                                            dispatch(findByIdDocument([event.documentId!])).then((document) => {
                                                                                //@ts-ignore
                                                                                dispatch(findFileById(document.payload[0].objectId)).then((e) => {
                                                                                    //@ts-ignore
                                                                                    objectService.downloadBase64WithExtension(document.payload[0].fileName, e.payload !== null ? e.payload : '')
                                                                                    dispatch(setFindDocumentStatus('idle'))
                                                                                    dispatch(setFindByIdDocumentStatus('idle'))
                                                                                })
                                                                            })
                                                                        }
                                                                    },
                                                                    {
                                                                        visible: event.type !== EventType.F24 ||
                                                                            (keycloak.hasRealmRole("financial_advisor") ||
                                                                                keycloak.hasRealmRole("financial_advisor_collaborator")
                                                                            ) ||
                                                                            event.f24Status !== DocumentF24Status.Idle ||
                                                                            companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                                                            (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                                                            (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company")),
                                                                        label: "Conferma pagamento",
                                                                        icon: <CheckIcon size={"24"} color={""} />,
                                                                        onClick: () => dispatch(updateStatusF24({ id: event.documentId!, data: { f24Status: DocumentF24Status.Pay } }))
                                                                    },
                                                                    {
                                                                        visible: event.type !== EventType.F24 ||
                                                                            (keycloak.hasRealmRole("financial_advisor") || keycloak.hasRealmRole("financial_advisor_collaborator"))
                                                                            || event.f24Status !== DocumentF24Status.Idle ||
                                                                            companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                                                            (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                                                            (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company")),
                                                                        label: "Posticipa",
                                                                        icon: <ClockIcon size={"24"} color={""} />,
                                                                        onClick: () => {
                                                                            dispatch(setDocumentId(event.documentId))
                                                                            dispatch(setUpdateStatusF24Modal(true))
                                                                        }
                                                                    },
                                                                    {
                                                                        label: 'Cancella',
                                                                        icon: <TrashIcon color="" size={""} />,
                                                                        onClick: () => {
                                                                            if (event.eventType === "event") {
                                                                                setIsDelete(event.id)
                                                                                dispatch(setOpenConfirmOrDenyModal(true))
                                                                            } else {
                                                                                setIsDeleteAppointment(event.id)
                                                                                dispatch(setOpenAppointmentConfirmOrDenyModal(true))
                                                                            }
                                                                        },
                                                                        visible: companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                                                            ((keycloak.hasRealmRole('company') || keycloak.hasRealmRole('administrative_company')) && event.type === EventType.F24) ||
                                                                            (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                                                            (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company")) ||
                                                                            (!authState.findMeFinancialAdvisorResponse?.isActive && keycloak.hasRealmRole("financial_advisor")) ||
                                                                            (!authState.findMeCollaboratorResponse?.isActive && keycloak.hasRealmRole("financial_advisor_collaborator"))
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                <span className={clsx("text-text-md font-semibold text-neutral-800")}>
                                                    {event.title.length <= 50 ? event.title : event.title.substring(0, 50).concat('...')}
                                                </span>
                                            </div>
                                            <span className={clsx("text-text-sm font-medium text-neutral-400")}>
                                                {event.note !== null && event.note.length < 140 ? event.note : event.note?.substring(0, 140).concat("...")}</span>
                                        </div>
                                        {
                                            eventByDay.values.length - 1 !== index &&
                                            <div
                                                className={"h-[1px] w-full self-center bg-neutral-200"}
                                            />
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                )
                setListedEvents(temp)
            })
            dispatch(setFindAllEventsStatus('idle'))
        }
    }, [eventsState.findAllEventsStatus, appointmentsState.appointments.company.status])


    return (
        <>
            {
                (window.location.pathname === "/calendar") ?
                    <LayoutComponent
                        menuItem={MenuItems.CALENDAR}
                        headingLabel={"Calendario"}
                        headingButtons={[
                            <ButtonComponent
                                label="Aggiungi scadenza"
                                size={"md"}
                                iconPosition={"off"}
                                variant={"outline"}
                                color={"blue"}
                                onClick={() => {
                                    dispatch(setModalEventType('save'))
                                    dispatch(setOpenNewEventsModal(true))
                                }}
                                disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                    (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                    (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))
                                }
                            />,
                            (keycloak.hasRealmRole("company") || keycloak.hasRealmRole('financial_advisor')) ?
                                <ButtonComponent
                                    label={keycloak.hasRealmRole('company') ? "Richiedi appuntamento" : 'Crea appuntamento'}
                                    size={"md"}
                                    iconPosition={"off"}
                                    variant={"solid"}
                                    color={"blue"}
                                    onClick={() => {
                                        dispatch(setModalAppointmentType("save"))
                                        dispatch(setNewAppointmentModal(true))
                                    }}
                                    disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                        (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                        (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))
                                    }
                                /> : <></>

                        ]}
                        breadcrumbItems={["Calendario"]}
                        breadcrumbIcon={<CalendarIcon size={"20"} color={layoutState.theme[500]} />}
                    >
                        {body}
                    </LayoutComponent>
                    :
                    <div className={"flex flex-col gap-6 w-full flex-grow"}>
                        <HeadingComponent
                            label={(keycloak.hasRealmRole('company') ? "Prossime scadenze di " : 'Eventi di ') + capitalize(format(eventsState.currentMonth, 'MMMM yyyy', { locale: it }))}
                            buttons={(keycloak.hasRealmRole('financial_advisor')) ? [<ButtonComponent
                                label="Aggiungi scadenza"
                                size={"md"}
                                iconPosition={"off"}
                                variant={"outline"}
                                color={"blue"}
                                onClick={() => {
                                    dispatch(setModalEventType('save'))
                                    dispatch(setOpenNewEventsModal(true))
                                }}
                                disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                    (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                    (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))
                                }
                            />,
                            <ButtonComponent
                                label={keycloak.hasRealmRole('company') ? "Richiedi appuntamento" : 'Crea appuntamento'}
                                size={"md"}
                                iconPosition={"off"}
                                variant={"solid"}
                                color={"blue"}
                                onClick={() => {
                                    dispatch(setModalAppointmentType("save"))
                                    dispatch(setNewAppointmentModal(true))
                                }}
                                disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                    (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                    (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))
                                }
                            />] :
                                keycloak.hasRealmRole('company') ? [] :
                                    [<ButtonComponent
                                        label="Aggiungi scadenza"
                                        size={"md"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        color={"blue"}
                                        onClick={() => {
                                            dispatch(setModalEventType('save'))
                                            dispatch(setOpenNewEventsModal(true))
                                        }}
                                        disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                            (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                            (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))
                                        }
                                    />]}
                            size={HeadingSize.MD}
                        />
                        {body}
                    </div>
            }
        </>
    )
}